import React from 'react'

const AppLogo = () => (
  <div className="app-logo">
    <img src="//www.dvo.com/images/cookn-logo.png" alt="Cook'n" />
    <h1 className="app-logo-text">Web App</h1>
  </div>
)

export default AppLogo



// WEBPACK FOOTER //
// ./src/Components/AppLogo.js